
import React from 'react';
import { PDFContentViewer } from './PDFContentViewer';

interface TrainingPDFContentViewerProps {
  fileUrl: string;
  isTrainee: boolean;
  isAdmin: boolean;
  onComplete?: () => void;
}

export function TrainingPDFContentViewer({
  fileUrl,
  isTrainee,
  isAdmin,
  onComplete
}: TrainingPDFContentViewerProps) {
  return (
    <PDFContentViewer
      fileUrl={fileUrl}
      isTrainee={isTrainee}
      isAdmin={isAdmin}
      onComplete={onComplete}
    />
  );
}
